module.exports = __webpack_public_path__ + "static/media/agente_blue.63739dbd.png";